import React from 'react';
import { Section } from './ui/Section';
// Custom SVG Icons
function GiftIcon({
  className
}: {
  className?: string;
}) {
  return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-10">
      <polyline points="20 12 20 22 4 22 4 12" data-id="element-11"></polyline>
      <rect x="2" y="7" width="20" height="5" data-id="element-12"></rect>
      <line x1="12" y1="22" x2="12" y2="7" data-id="element-13"></line>
      <path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z" data-id="element-14"></path>
      <path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z" data-id="element-15"></path>
    </svg>;
}
function CheckIcon({
  className
}: {
  className?: string;
}) {
  return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-16">
      <polyline points="20 6 9 17 4 12" data-id="element-17"></polyline>
    </svg>;
}
function SparkleIcon({
  className
}: {
  className?: string;
}) {
  return <svg className={className} viewBox="0 0 24 24" fill="currentColor" data-id="element-18">
      <path d="M12 0L14.59 9.41L24 12L14.59 14.59L12 24L9.41 14.59L0 12L9.41 9.41L12 0Z" data-id="element-19" />
    </svg>;
}
export function Bonuses() {
  const bonuses = [{
    number: 1,
    title: 'Pack Portadas Premium',
    subtitle: '10 Portadas Editables en Gamma (desde el celular)',
    hook: 'Tu PDF puede ser simple... pero tiene que verse pagable.',
    description: 'Este bono está diseñado para que tu producto no se vea "casero" ni improvisado, sino limpio, moderno, premium.',
    includes: ['10 estilos de portada listos para replicar en Gamma', 'Fórmulas de títulos que suenan a producto real (sin hype)', 'Checklist "No se ve amateur" antes de exportar'],
    result: 'Tu PDF se ve como algo que la gente compra, no como algo que regalan.',
    image: 'https://cdn.magicpatterns.com/uploads/oPjbSiyoEGgPdKx1TT2bff/bono_1.png'
  }, {
    number: 2,
    title: 'Oferta Express (15 Min)',
    subtitle: 'Tu Precio + Tu Paquete Sin Dudar',
    hook: 'La mayoría no falla por falta de talento. Falla por esto: no cierra la oferta... y por eso le da pena cobrar.',
    description: 'Con este bono sales con tu oferta lista y un precio que puedes decir sin temblar.',
    includes: ['Plantilla "Mi oferta en 6 líneas" (rellenable)', 'Tabla de precio (Starter / Standard / Premium)', '12 frases para decir tu precio sin justificarte'],
    result: 'Publicas con seguridad, sin rebajar, sin pedir permiso.',
    image: 'https://cdn.magicpatterns.com/uploads/1idxmYwwtZbiXSe3Yuj4dx/bono_2.png'
  }, {
    number: 3,
    title: 'Entrega Pro (Celular)',
    subtitle: 'Envío Premium + Testimonios',
    hook: 'Una entrega desordenada mata la confianza. Una entrega limpia te convierte en marca.',
    description: 'Este bono te deja un sistema simple para entregar tu PDF como profesional y encima conseguir testimonios.',
    includes: ['Checklist de entrega perfecta (paso a paso)', 'Mensajes listos (WhatsApp + Instagram)', 'Follow-up 24h + guion para pedir testimonio sin incomodar'],
    result: 'Cada venta se siente pro, y las siguientes se vuelven más fáciles.',
    image: 'https://cdn.magicpatterns.com/uploads/1SJ87rmaR1AxATNiHAPpKu/bono_3.png'
  }];
  return <Section className="bg-brand-dark text-white !pt-4 md:!pt-10" data-id="element-20">
      {/* Header */}
      <div className="text-center mb-8 md:mb-12" data-id="element-21">
        <div className="inline-flex items-center gap-2 bg-amber-500/20 text-amber-400 px-3 py-1.5 md:px-4 md:py-2 rounded-full text-xs md:text-sm font-bold mb-4 md:mb-6 border border-amber-500/30" data-id="element-22">
          <GiftIcon className="w-4 h-4 md:w-5 md:h-5" data-id="element-23" />
          <span data-id="element-24">BONOS EXCLUSIVOS</span>
        </div>

        <h2 className="text-2xl md:text-4xl font-bold text-white mb-3 md:mb-4" data-id="element-25">
          Hoy te llevas 3 Bonos de Lujo{' '}
          <span className="text-amber-400" data-id="element-26">(Valor $47)</span> — GRATIS
        </h2>

        <p className="text-gray-400 max-w-2xl mx-auto text-sm md:text-lg" data-id="element-27">
          No quiero que compres Mamá Digital 2.0 y después te quedes trabada en
          lo típico: "no sé cómo hacerlo ver pro", "no sé qué precio poner", "¿y
          si entrego mal?".
        </p>

        <p className="text-gray-300 mt-3 md:mt-4 font-medium text-sm md:text-base" data-id="element-28">
          Por eso, si entras hoy, desbloqueas automáticamente estos 3 bonos.
        </p>

        <div className="mt-4 md:mt-6 inline-block bg-gray-800 rounded-lg px-4 md:px-6 py-2 md:py-3 border border-gray-700" data-id="element-29">
          <span className="text-gray-400 line-through mr-2 md:mr-3 text-sm md:text-base" data-id="element-30">
            Valor total: $47
          </span>
          <span className="text-emerald-400 font-bold text-sm md:text-lg" data-id="element-31">
            Hoy: $0 (gratis con tu compra)
          </span>
        </div>
      </div>

      {/* Bonuses Grid */}
      <div className="space-y-6 md:space-y-12 max-w-5xl mx-auto" data-id="element-32">
        {bonuses.map((bonus, index) => <div key={index} className="bg-gray-800/50 rounded-xl md:rounded-2xl overflow-hidden border border-gray-700" data-id="element-33">
            <div className="grid md:grid-cols-2 gap-0" data-id="element-34">
              {/* Image */}
              <div className={`${index % 2 === 1 ? 'md:order-2' : ''}`} data-id="element-35">
                <img src={bonus.image} alt={bonus.title} className="w-full h-48 md:h-full object-cover md:min-h-[280px]" data-id="element-36" />
              </div>

              {/* Content */}
              <div className="p-5 md:p-8" data-id="element-37">
                <div className="flex items-center gap-3 mb-3 md:mb-4" data-id="element-38">
                  <span className="bg-brand-pink text-brand-dark text-xs md:text-sm font-bold px-2 md:px-3 py-1 rounded-full" data-id="element-39">
                    BONO #{bonus.number}
                  </span>
                </div>

                <h3 className="text-xl md:text-2xl font-bold text-white mb-1 md:mb-2" data-id="element-40">
                  {bonus.title}
                </h3>

                <p className="text-brand-pink font-medium mb-3 md:mb-4 text-sm md:text-base" data-id="element-41">
                  {bonus.subtitle}
                </p>

                <p className="text-gray-300 italic mb-3 md:mb-4 text-sm md:text-base" data-id="element-42">
                  {bonus.hook}
                </p>

                <p className="text-gray-400 mb-4 md:mb-6 text-sm md:text-base" data-id="element-43">
                  {bonus.description}
                </p>

                <div className="mb-4 md:mb-6" data-id="element-44">
                  <p className="text-xs md:text-sm text-gray-500 uppercase tracking-wide mb-2 md:mb-3 font-semibold" data-id="element-45">
                    Incluye:
                  </p>
                  <ul className="space-y-1.5 md:space-y-2" data-id="element-46">
                    {bonus.includes.map((item, i) => <li key={i} className="flex items-start text-gray-300" data-id="element-47">
                        <CheckIcon className="w-4 h-4 md:w-5 md:h-5 text-emerald-400 mr-2 mt-0.5 flex-shrink-0" data-id="element-48" />
                        <span className="text-xs md:text-sm" data-id="element-49">{item}</span>
                      </li>)}
                  </ul>
                </div>

                <div className="bg-emerald-500/10 border border-emerald-500/30 rounded-lg p-3 md:p-4" data-id="element-50">
                  <div className="flex items-start gap-2" data-id="element-51">
                    <SparkleIcon className="w-3 h-3 md:w-4 md:h-4 text-emerald-400 mt-1 flex-shrink-0" data-id="element-52" />
                    <p className="text-emerald-400 font-medium text-xs md:text-sm" data-id="element-53">
                      <span className="font-bold" data-id="element-54">Resultado:</span>{' '}
                      {bonus.result}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>)}
      </div>

      {/* Summary */}
      <div className="mt-8 md:mt-12 text-center" data-id="element-55">
        <div className="bg-gradient-to-r from-amber-500/10 via-brand-pink/10 to-amber-500/10 rounded-xl md:rounded-2xl p-5 md:p-8 border border-amber-500/20 max-w-2xl mx-auto" data-id="element-56">
          <h3 className="text-lg md:text-xl font-bold text-white mb-3 md:mb-4" data-id="element-57">
            Resumen rápido
          </h3>
          <div className="space-y-2 md:space-y-3" data-id="element-58">
            <div className="flex items-center justify-center gap-2 md:gap-3" data-id="element-59">
              <CheckIcon className="w-4 h-4 md:w-5 md:h-5 text-emerald-400" data-id="element-60" />
              <span className="text-gray-300 text-sm md:text-base" data-id="element-61">
                Valor de los 3 bonos:{' '}
                <span className="text-white font-bold" data-id="element-62">$47</span>
              </span>
            </div>
            <div className="flex items-center justify-center gap-2 md:gap-3" data-id="element-63">
              <CheckIcon className="w-4 h-4 md:w-5 md:h-5 text-emerald-400" data-id="element-64" />
              <span className="text-gray-300 text-sm md:text-base" data-id="element-65">
                Hoy: <span className="text-emerald-400 font-bold" data-id="element-66">GRATIS</span>{' '}
                con tu compra
              </span>
            </div>
            <div className="flex items-center justify-center gap-2 md:gap-3" data-id="element-67">
              <CheckIcon className="w-4 h-4 md:w-5 md:h-5 text-emerald-400" data-id="element-68" />
              <span className="text-gray-300 text-sm md:text-base" data-id="element-69">
                Se desbloquean automáticamente al entrar a Mamá Digital 2.0
              </span>
            </div>
          </div>
        </div>
      </div>
    </Section>;
}